import { useState } from "react";
import { btn3d } from "../styles/buttonStyles";

export default function RangeCalendarPicker({ label, startDate, endDate, onChange, darkMode=false }) {
  const dm = darkMode;
  const today = new Date(); today.setHours(0,0,0,0);
  const [viewYear, setViewYear] = useState(today.getFullYear());
  const [viewMonth, setViewMonth] = useState(today.getMonth());
  const [hoverDate, setHoverDate] = useState(null);
  const [dayTrip, setDayTrip] = useState(false);
  const WEEKDAYS = ["일","월","화","수","목","금","토"];
  const MONTHS = ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"];
  const toStr = (y,m,d) => `${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  const toObj = s => s ? new Date(s+"T00:00:00") : null;
  const todayStr = toStr(today.getFullYear(), today.getMonth(), today.getDate());
  const firstDay = new Date(viewYear,viewMonth,1).getDay();
  const daysInMonth = new Date(viewYear,viewMonth+1,0).getDate();
  const prevMonth = () => { if(viewMonth===0){setViewYear(y=>y-1);setViewMonth(11);}else setViewMonth(m=>m-1); };
  const nextMonth = () => { if(viewMonth===11){setViewYear(y=>y+1);setViewMonth(0);}else setViewMonth(m=>m+1); };

  const toggleDayTrip = () => {
    const next = !dayTrip;
    setDayTrip(next);
    if(next && startDate) {
      onChange({ startDate, endDate: startDate });
    } else if(!next && startDate) {
      onChange({ startDate, endDate: "" });
    }
  };

  const handleDay = dateStr => {
    const clicked = new Date(dateStr+"T00:00:00");
    if(clicked<today) return;
    if(dayTrip) {
      onChange({ startDate: dateStr, endDate: dateStr });
      return;
    }
    if(!startDate||(startDate&&endDate)) { onChange({startDate:dateStr,endDate:""}); return; }
    const start = toObj(startDate);
    if(clicked<start) { onChange({startDate:dateStr,endDate:startDate}); }
    else if(clicked.getTime()===start.getTime()) { onChange({startDate:dateStr,endDate:""}); }
    else { onChange({startDate,endDate:dateStr}); }
  };
  const isInRange = dateStr => {
    if(dayTrip) return false;
    const eff = endDate||hoverDate;
    if(!startDate||!eff) return false;
    const d=new Date(dateStr+"T00:00:00"), s=toObj(startDate), e=new Date(eff+"T00:00:00");
    const [mn,mx] = s<=e?[s,e]:[e,s];
    return d>mn && d<mx;
  };
  const nights = (startDate&&endDate) ? Math.round((toObj(endDate)-toObj(startDate))/(864e5)) : null;
  const isDayTrip = dayTrip || (startDate && endDate && startDate===endDate);
  const cells = [...Array(firstDay).fill(null), ...Array.from({length:daysInMonth},(_,i)=>i+1)];
  return (
    <fieldset style={{ margin:0, marginBottom:18, padding:0, border:0, minWidth:0 }}>
      <legend style={{ display:"block", width:"100%", padding:0, fontSize:11, fontWeight:700, letterSpacing:"0.1em", color:"var(--accent)", marginBottom:10, textTransform:"uppercase" }}>{label}</legend>
      <div style={{ display:"flex", gap:8, marginBottom:8 }}>
        {isDayTrip ? (
          <div style={{ flex:1, padding:"9px 12px", borderRadius:9, background: startDate?dm?"rgba(255,255,255,0.07)":"rgba(255,255,255,0.85)":dm?"rgba(255,255,255,0.03)":"rgba(255,255,255,0.5)", border:`1px solid ${startDate?"rgba(99,102,241,0.6)":"rgba(99,102,241,0.1)"}` }}>
            <div style={{ fontSize:10, fontWeight:700, color:"var(--accent)", letterSpacing:"0.08em", marginBottom:2 }}>여행일</div>
            <div style={{ fontSize:13, fontWeight:800, color: startDate?"var(--text)":dm?"rgba(226,232,240,0.73)":"rgba(100,116,139,0.6)" }}>{startDate?startDate.replace(/-/g,"."):"미선택"}</div>
          </div>
        ) : (
          [{label:"출발",val:startDate,color:"#6366F1"},{label:"도착",val:endDate,color:"#8B5CF6"}].map(({label:lbl,val,color})=>(
            <div key={lbl} style={{ flex:1, padding:"9px 12px", borderRadius:9, background: val?dm?"rgba(255,255,255,0.07)":"rgba(255,255,255,0.85)":dm?"rgba(255,255,255,0.03)":"rgba(255,255,255,0.5)", border:`1px solid ${val?color+"55":"rgba(99,102,241,0.1)"}` }}>
              <div style={{ fontSize:10, fontWeight:700, color: val?color:"rgba(51,65,85,0.65)", letterSpacing:"0.08em", marginBottom:2 }}>{lbl}</div>
              <div style={{ fontSize:13, fontWeight:800, color: val?"var(--text)":dm?"rgba(226,232,240,0.73)":"rgba(100,116,139,0.6)" }}>{val?val.replace(/-/g,"."):"미선택"}</div>
            </div>
          ))
        )}
        {isDayTrip ? (
          <div style={{ padding:"9px 12px", borderRadius:9, background:"rgba(99,102,241,0.1)", border:"1px solid rgba(99,102,241,0.35)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minWidth:54 }}>
            <div style={{ fontSize:10, fontWeight:700, color:"var(--accent)", marginBottom:1 }}>기간</div>
            <div style={{ fontSize:14, fontWeight:900, color:"var(--accent)", }}>당일</div>
          </div>
        ) : nights!==null&&(
          <div style={{ padding:"9px 12px", borderRadius:9, background:"rgba(99,102,241,0.1)", border:"1px solid rgba(99,102,241,0.35)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
            <div style={{ fontSize:10, fontWeight:700, color:"var(--accent)", marginBottom:1 }}>기간</div>
            <div style={{ fontSize:14, fontWeight:900, color:"var(--accent)", }}>{nights}박</div>
            <div style={{ fontSize:10, fontWeight:700, color:dm?"rgba(226,232,240,0.7)":"rgba(71,85,105,0.75)" }}>{nights+1}일</div>
          </div>
        )}
      </div>
      <div style={{ background:dm?"rgba(255,255,255,0.05)":"rgba(255,255,255,0.8)", border:dm?"1px solid rgba(99,102,241,0.2)":"1px solid rgba(99,102,241,0.2)", borderRadius:14, padding:14 }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12 }}>
          <button type="button" onClick={prevMonth} aria-label="이전 달 보기" className="btn3d" style={{ ...btn3d("outline", dm), width:38, height:38, padding:0, borderRadius:10, fontSize:18 }}>&#8249;</button>
          <span style={{ fontWeight:800, fontSize:14, color:dm?"rgba(226,232,240,0.9)":"rgba(30,41,59,0.85)", }}>{viewYear}년 {MONTHS[viewMonth]}</span>
          <button type="button" onClick={nextMonth} aria-label="다음 달 보기" className="btn3d" style={{ ...btn3d("outline", dm), width:38, height:38, padding:0, borderRadius:10, fontSize:18 }}>&#8250;</button>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2, marginBottom:4 }}>
          {WEEKDAYS.map((d,i)=><div key={d} style={{ textAlign:"center", fontSize:10, fontWeight:700, padding:"3px 0", color: i===0?"#C04040":i===6?"#2060B0":"rgba(71,85,105,0.5)" }}>{d}</div>)}
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2 }}>
          {cells.map((day,i) => {
            if(!day) return <div key={`e${i}`}/>;
            const dateStr = toStr(viewYear,viewMonth,day);
            const isStart=dateStr===startDate, isEnd=dateStr===endDate;
            const inRange=isInRange(dateStr), isToday=dateStr===todayStr;
            const isPast=new Date(dateStr+"T00:00:00")<today;
            const col=i%7;
            let bg="transparent", tc=isPast?dm?"rgba(226,232,240,0.70)":"rgba(100,116,139,0.60)":col===0?dm?"#ff8a8a":"#C04040":col===6?dm?"#7ec8ff":"#3070C0":dm?"rgba(226,232,240,0.85)":"rgba(30,41,59,0.82)";
            let br="9px", fw=500;
            if(isStart){bg="#6366F1";tc="#FFFFFF";fw=900;br=isDayTrip?"9px":"9px 0 0 9px";}
            if(isEnd&&!isDayTrip){bg="#8B5CF6";tc="#FFFFFF";fw=900;br="0 9px 9px 0";}
            if(isStart&&isEnd){bg="#6366F1";tc="#FFFFFF";br="9px";}
            if(inRange){bg="rgba(99,102,241,0.12)";br="0";}
            return (
              <div key={day} onClick={()=>!isPast&&handleDay(dateStr)}
                onMouseEnter={()=>{if(!dayTrip&&startDate&&!endDate)setHoverDate(dateStr);}}
                onMouseLeave={()=>setHoverDate(null)}
                style={{ textAlign:"center", minHeight:38, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:fw, WebkitTapHighlightColor:"transparent", background:bg, color:tc, borderRadius:br, border: isToday&&!isStart&&!isEnd?"1px solid rgba(129,140,248,0.4)":"1px solid transparent", cursor: isPast?"not-allowed":"pointer", transition:"background 0.1s", position:"relative" }}>
                {day}
                {isStart&&isDayTrip&&<div style={{ position:"absolute", bottom:1, left:"50%", transform:"translateX(-50%)", fontSize:6, color:"#fff", fontWeight:900 }}>당일</div>}
                {isStart&&!isDayTrip&&<div style={{ position:"absolute", bottom:1, left:"50%", transform:"translateX(-50%)", fontSize:6, color:"#fff", fontWeight:900 }}>출발</div>}
                {isEnd&&!isDayTrip&&<div style={{ position:"absolute", bottom:1, left:"50%", transform:"translateX(-50%)", fontSize:6, color:"#fff", fontWeight:900 }}>도착</div>}
              </div>
            );
          })}
        </div>

        {/* 당일여행 체크박스 */}
        <div style={{ marginTop:12, paddingTop:12, borderTop:"1px dashed rgba(99,102,241,0.18)", display:"flex", alignItems:"center", gap:10 }}>
          <input
            id="travel-day-trip"
            type="checkbox"
            checked={dayTrip}
            onChange={toggleDayTrip}
            style={{ width:22, height:22, flexShrink:0, cursor:"pointer", accentColor:"var(--accent)" }}
          />
          <label htmlFor="travel-day-trip" style={{ cursor:"pointer", userSelect:"none" }}>
            <span style={{ fontSize:13, fontWeight:700, color:"var(--text)" }}>당일여행</span>
            <span style={{ fontSize:11, color:dm?"rgba(226,232,240,0.70)":"rgba(51,65,85,0.68)", marginLeft:6 }}>하루만 선택됩니다</span>
          </label>
          {dayTrip&&(
            <span style={{ marginLeft:"auto", fontSize:10, padding:"2px 8px", borderRadius:100, background:"rgba(99,102,241,0.15)", border:"1px solid rgba(99,102,241,0.4)", color:"var(--accent)", fontWeight:700 }}>0박 1일</span>
          )}
        </div>

        <div style={{ marginTop:8, fontSize:11, color:dm?"rgba(226,232,240,0.65)":"rgba(51,65,85,0.68)", textAlign:"center" }}>
          {dayTrip
            ? (startDate?"날짜를 다시 클릭하면 변경됩니다":"여행할 날짜를 선택해주세요")
            : (!startDate?"출발일을 먼저 선택해주세요":!endDate?"도착일을 선택해주세요":"범위를 변경하려면 다시 클릭하세요")
          }
        </div>

      </div>
    </fieldset>
  );
}
